import { ORDER_DIALOG_MESSAGES, OrderDialogMessages } from "./order-dialog.messages";
import { ORDERS_FILTER_MESSAGES, OrdersFiltersMessages } from "./order-filters.messages";
import { ORDER_REQUEST_MESSAGES, OrderRequestMessages } from "./order-request-messages";
import { ORDERS_TABLE_MESSAGES, OrdersTableMessages } from "./orders-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type OrdersMessages = OrdersFiltersMessages &
  OrdersTableMessages &
  SidebarMessages &
  OrderRequestMessages &
  OrderDialogMessages &
  ActionButtonMessages & {
    ordersPageTitle: string;
    orderBreadCrumbTitle: string;
    addOrderButton: string;

    //Remove order dialog
    cancelOrderDialogTitle: string;
    cancelOrderDialogContent: string;
    cancelOrderSuccess: string;
  };

export const ORDERS_MESSAGES: OrdersMessages = {
  ordersPageTitle: "Pedidos",
  orderBreadCrumbTitle: "Pedidos",
  addOrderButton: "Novo pedido",

  ...ORDER_DIALOG_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ORDER_REQUEST_MESSAGES,
  ...ORDERS_FILTER_MESSAGES,
  ...ORDERS_TABLE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default ORDERS_MESSAGES;
